import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "hotspot-module__scene" }
const _hoisted_2 = { class: "hotspot-scene__tabs" }
const _hoisted_3 = { class: "hotspot-scene__tabs-list" }

import {onMounted, ref, computed, watchEffect, onUpdated} from 'vue';
import HotspotScene from 'Vue/components/hotspotComponents/HotspotScene.vue';
import {AdvancedHotspots, Scene} from 'Interfaces/interfaces';
import SceneTab from "Vue/components/hotspotComponents/SceneTab.vue";
import HotspotContent from "Vue/components/hotspotComponents/HotspotContent.vue";
import HotspotsModal from "Vue/components/hotspotComponents/HotspotsModal.vue";
const componentName = 'AdvancedHotspots';

export default /*#__PURE__*/_defineComponent({
  __name: 'AdvancedHotspots',
  setup(__props) {

const hotspotData = ref<AdvancedHotspots | null>(null);
const activeIndex = ref<number>(0);
const modalVisible = ref<boolean>(false);
const activeHotspotIndex = ref<number>(0);
const hotspotmod = ref(null);
const topPosition = ref(null);
const activeScene = ref<Scene | null>(null);
const scenes = computed(() => {
	return hotspotData.value?.Scenes || [];
});

const castedScenes = computed(() => {
	return scenes.value.map((scene: any) => scene as Scene);
});

const updateVisibleSceneIndex = (index: number) => {
	activeIndex.value = index;
};

const modalVisibilityUpdated = (value) => {
	modalVisible.value = value;
};

const scrollUpdate = () => {
	// Scroll to the top of the element smoothly
	// if (hotspotmod.value) {
	// 	hotspotmod.value.focus();
	// }


	window.scrollTo({
		top: topPosition.value,
		behavior: 'smooth' // for smooth scrolling
	});
}

const updateChosenScene = (scene) => {
	activeScene.value = scene;
};

const updateActiveHotspotIndex = (indexValue) => {
	activeHotspotIndex.value = indexValue;
}

const handleWindowResize = () => {
	if (hotspotmod.value) {
		topPosition.value = hotspotmod.value.offsetTop;
	}
};

onMounted(() => {
	const element = document.querySelector('.js-advanced-hotspots');
	if (element) {
		const dataAttribute = element.getAttribute('data-hotspotdata');
		if (dataAttribute) {
			hotspotData.value = JSON.parse(dataAttribute) as AdvancedHotspots;
		}
	}

	topPosition.value = hotspotmod.value.offsetTop;

	// Preload images
	castedScenes.value.forEach(scene => {
		const img = new Image();
		img.src = scene.BackgroundImage;
	});

	activeScene.value = castedScenes.value[0];

	updateVisibleSceneIndex(0);
	window.addEventListener('resize', handleWindowResize);


	if ('scrollRestoration' in history) {
		// Back off, browser, I got this...
		history.scrollRestoration = 'manual';
	}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "hotspot-module",
      ref_key: "hotspotmod",
      ref: hotspotmod,
      tabindex: "0"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(castedScenes.value, (scene, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: scene.DisplayTitle
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createBlock(HotspotScene, {
              key: scene.DisplayTitle,
              backgroundImage: scene.BackgroundImage,
              sceneAssociatedColor: scene.SceneAssociatedColor,
              caption: scene.Caption,
              captionTitle: scene.CaptionTitle,
              activeIndex: activeIndex.value,
              displayTitle: scene.DisplayTitle,
              hotspotPlacements: scene.HotSpotPlacements,
              title: scene.Title,
              modalVisible: modalVisible.value,
              onUpdateActiveHotspotIndex: updateActiveHotspotIndex,
              onModalVisibilityUpdated: modalVisibilityUpdated
            }, null, 8 /* PROPS */, ["backgroundImage", "sceneAssociatedColor", "caption", "captionTitle", "activeIndex", "displayTitle", "hotspotPlacements", "title", "modalVisible"]))
          ], 512 /* NEED_PATCH */), [
            [_vShow, index === activeIndex.value]
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(castedScenes.value, (scene, index) => {
          return (_openBlock(), _createBlock(SceneTab, {
            key: scene.DisplayTitle,
            index: index,
            scene: scene,
            tabName: scene.DisplayTitle,
            activeIndex: activeIndex.value,
            sceneAssociatedColor: scene.SceneAssociatedColor,
            onUpdateVisibleSceneIndex: updateVisibleSceneIndex,
            onUpdateChosenScene: updateChosenScene,
            onScrollUpdate: scrollUpdate
          }, null, 8 /* PROPS */, ["index", "scene", "tabName", "activeIndex", "sceneAssociatedColor"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        name: "fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          (modalVisible.value)
            ? (_openBlock(), _createBlock(HotspotsModal, {
                key: 0,
                onModalVisibilityUpdated: modalVisibilityUpdated
              }, {
                default: _withCtx(() => [
                  _createVNode(HotspotContent, {
                    hotspotPlacements: activeScene.value.HotSpotPlacements,
                    backgroundImage: activeScene.value.BackgroundImage,
                    activeHotspotIndex: activeHotspotIndex.value,
                    onUpdateActiveHotspotIndex: updateActiveHotspotIndex
                  }, null, 8 /* PROPS */, ["hotspotPlacements", "backgroundImage", "activeHotspotIndex"])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})